module.exports = __webpack_public_path__ + "static/taco-bowls-37a5e8cbb964354d2e29866b0179d1a3.jpg";